module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "members"
  }, [_c('el-tabs', {
    staticClass: "content",
    attrs: {
      "theme": "info",
      "value": _vm.canDo('view_members') ? 'details' : 'logs'
    }
  }, [(_vm.canDo('view_members')) ? _c('el-tab-pane', {
    attrs: {
      "label": "成员信息",
      "name": "details"
    }
  }, [_c('details-card')], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "操作日志",
      "name": "logs"
    }
  }, [_c('logs-card')], 1), _vm._v(" "), (_vm.canDo('edit_members') && !_vm.tbcMode) ? _c('el-tab-pane', {
    attrs: {
      "label": "权限管理",
      "name": "permissions"
    }
  }, [_c('permissions-card')], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca12b770"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/members/index.vue
// module id = 947
// module chunks = 3